<div id="page">
  <nav class="fh5co-nav" role="navigation"
    style="background-color:rgba(0, 0, 0, 0.85); color: rgba(255, 255, 255, 0.6); ">
    <div class="fh5co-nav">
      <div class="top" style="padding:0px auto;">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 text-center" style="text-align: center;">
              <ul class="fh5co-social" style="list-style: none; display: inline-block;">
                <li class="active" style="display: inline;"><a href="https://www.facebook.com/SourceCode.tw/"><i
                      class="icon-facebook2"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a href="https://www.linkedin.com/company/sourcecodetw/"><i
                      class="icon-linkedin2"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a [routerLink]="['/index']"><i class="icon-home-outline"
                      style=" color: rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
                <li class="active" style="display: inline;"><a [routerLink]="['/message']"><i class="icon-message"
                      style=" color:rgba(255, 255, 255, 0.6); display: inline !important;"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-xs-6 text-left">
          <div id="fh5co-logo"><a href="index.html" class="navbar-brand mr-lg-5"
              style=" color: #ffffff; font-size: 20px;">原碼後台管理</a></div>
        </div>
        <div class="col-xs-6 text-right menu-1">
          <ul>
            <li class="btn-cta"><a href="https://www.sourcecode.tw/SourceCode/#/home"><span>返回原碼</span></a></li>
            <li class="btn-cta"><a [routerLink]="['/message']"><span>聯絡我們</span></a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <ul class="slides">
    <li style="background-image: url(./assets/images/message_bg.jpg); background-size:cover; height: 80vh;">
      <div class="overlay-gradient"></div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center slider-text">
            <div class="slider-text-inner">
              <div class="container">
                <div class="row">
                  <div class="col-md-7 text-left message">
                    <div class="display-t">
                      <div class="message-box" data-animate-effect="fadeInUp" style="padding:10% 0%; margin-top: auto;">
                        <h3 style="text-align: center; color: #45C1E5; font-weight: bold;">免費體驗</h3>
                        <h5 style="text-align: center; color: #ffffff; font-weight: bold;">請填寫您的詳細資料，然後按「立即體驗」按鈕開始體驗。</h5>
                        <form role="form" [formGroup]="messageForm" (ngSubmit)="onSubmit()">
                          <input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
                      placeholder="*姓名(必填)" required formControlName="messagerName">
											<input type="email" class="form-control form-control-alternative" id="exampleFormControlInput1"
												placeholder="*電子郵件地址(必填)" required formControlName="messageEmail">
											<input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
												placeholder="*組織名稱(必填)" required formControlName="messageCompany">
											<input type="text" class="form-control form-control-alternative" id="exampleFormControlInput1"
												placeholder="*聯絡電話(必填)" required formControlName="messagePhone">
                          <div class="text-center">
                            <button type="submit" class="btn btn-default my-4" id=free [disabled]="messageForm.invalid">聯絡我們</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>


  <footer id="fh5co-footer" role="contentinfo">
    <div class="overlay"></div>
    <div class="container">
      <div class="row copyright">
        <div class="col-md-12 text-center">
          <p>
            <small class="block">&copy; 2020 原碼數位科技有限公司</small>
            <small class="block">新北市中和區建八路2號4樓之7&nbsp;&nbsp;<a href="tel:02-8228-0407">(02)8228-0407</a></small>
          </p>
        </div>
      </div>
    </div>
  </footer>

  <div class="gototop js-top">
    <a href="#" class="js-gotop"><i class="icon-arrow-up"></i></a>
  </div>
